import axios from 'axios';
import Settings from '../../../settings.json';

const url = Settings.isNative ? Settings.frontlineArServer : '';

export class GroupsRequester {

    static async createGroup(workspace) {
        const result = await axios.post(`${url}/GroupsManagement/${workspace}/CreateGroup`);
        return result.data;
    }

    static async getAccessForPage(workspace, {targetId, targetIds, inheritedIds, nestedRoute, isProjectLevel = false}) {
        const result = await axios.post(`${url}/GroupsManagement/${workspace}/GetAccessForPage`, {targetId, targetIds, inheritedIds, nestedRoute, isProjectLevel});
        return result.data;
    }

    static async getAccessForItems(workspace, {itemIds, searchIds}) {
        const result = await axios.post(`${url}/GroupsManagement/${workspace}/GetAccessForItems`, {itemIds, searchIds});
        return result.data;
    }

    static async getItemAccessSources(workspace, {itemId, nestedRoute}) {
        const result = await axios.post(`${url}/GroupsManagement/${workspace}/GetItemAccessSources`, {itemId, nestedRoute});
        return result.data;
    }

    static async saveItemAccess(workspace, payload) {
        const result = await axios.post(`${url}/GroupsManagement/${workspace}/SaveItemAccess`, payload);
        return result.data;
    }

    static async getInheritedAccessSummary(workspace, groupIds) {
        const result = await axios.post(`${url}/GroupsManagement/${workspace}/GetInheritedAccessSummary`, {groupIds});
        return result.data;
    }
}
